import * as React from "react";
import Config from "../../Config";

/**
 * Parent component that modal components inherit from
 */
export default class ModalComponent extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            openModal: false,
        }

        Config.getConfig();
    }

    /**
     * Open/close modal
     */
    toggleModal = () =>
    {
        this.setState(prevState => ({
            openModal: !prevState.openModal,
        }));
    }

    openModal = () =>
    {
        if (!this.state.openModal)
        {
            this.setState({
                openModal: true
            });
        }
    }

    closeModal = () =>
    {
        if (this.state.openModal)
        {
            this.setState({
                openModal: false
            });
        }
    }
}
